import { PortfolioSourcesService_portfolioSourcesServiceGetStopsLatest } from '@festina/unitlink-general-types/unitlink/hooks/PortfolioSourcesStopsService_portfolioSourcesServiceGetStopsLatest'

export const useFetchUnitlinkStopFlags =
  PortfolioSourcesService_portfolioSourcesServiceGetStopsLatest.useQuery
